import { Stack } from "@mui/material";
import type { OpenModal } from "../hooks/useModal";
import type { MediaGrid, MediaGridProps } from "../types";
import { BulkActions } from "./BulkActions";
import { Search } from "./Search";
import { Selected } from "./Selected";

interface Props {
	setSearchText: (value: string) => void;
	mediaGrid: MediaGrid;
	openModal: OpenModal;
}

export const Toolbar = (props: Props) => {
	const { setSearchText, mediaGrid, openModal } = props;
	const bulkProps: MediaGridProps = {
		...mediaGrid,
		openModal,
	};

	return (
		<Stack direction="row" justifyContent="space-between" flexShrink={0}>
			<Stack direction="row">
				<Search setSearchText={setSearchText} />
				<Selected mediaGrid={mediaGrid} />
			</Stack>
			<BulkActions {...bulkProps} />
		</Stack>
	);
};
